export class ControlTeam {
    id: number;
    name: string;
    createdBy: string;
    createDate: Date;
    controllers = [];
    description: string;
    lastModifiedBy: string;
  }